import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { ROUTE_AUTH_LOGIN } from '../util/constants';

interface Props {
  children: JSX.Element;
}

/** A fleet driver login, or a fleet manager (who can sign vehicles out too). */
export default function RequiredFleetDriver({ children }: Props) {
  const currentUser = useAppSelector((state) => state.auth.currentUser);
  const location = useLocation();
  const roles = currentUser.roles || [];

  if (!roles.includes('fleet_driver') && !roles.includes('fleet_manager')) {
    return <Navigate to={ROUTE_AUTH_LOGIN} state={{ from: location }} />;
  }

  return children;
}
